import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import ApiEvento from '../services/eventoService';

const ModalParticipantes = ({ show, onClose, evento, modalidadeEvento }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [participantes, setParticipantes] = useState([]);
    const renderListaTexto = (valor) => {
        if (!valor) return '-';

        return (
            <div className="d-flex flex-column gap-1 wrap-text">
                {valor.split(' && ').map((item, index) => (
                    <span key={index}>{item}</span>
                ))}
            </div>
        );
    };

    const renderListaImagem = (valor) => {
        if (!valor) {
            return (
                <img
                    src="/avatar-default.png"
                    width="40"
                    height="40"
                    className="rounded-circle"
                    alt="Sem foto"
                />
            );
        }

        return (
            <div className="d-flex flex-column gap-1">
                {valor.split(' && ').map((src, index) => (
                    <img
                        key={index}
                        src={src}
                        alt="Participante"
                        width="40"
                        height="40"
                        className="rounded-circle"
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = '/avatar-default.png';
                        }}
                    />
                ))}
            </div>
        );
    };

    const fetchInscritos = async () => {
        if (!evento?.id) return;

        setIsLoading(true);

        try {
            const response = await ApiEvento.obterInscritosPorIdModalidade(
                evento.id,
                modalidadeEvento
            );
            setParticipantes(response.data);
        } catch (error) {
            console.error('Erro ao buscar inscritos:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const calcularTotalInscritos = () => {
        return participantes.reduce((total, participante) => {
            if (!participante.nome) {
                return total;
            }

            return total + participante.nome.split(' && ').length;
        }, 0);
    };

    useEffect(() => {
        if (show) {
            fetchInscritos();
        }
    }, [show, evento?.id]);

    if (!show) return null;

    /* =========================
       Render
    ========================== */

    return (
        <div
            className="modal fade show d-block"
            tabIndex="-1"
            style={{ backgroundColor: 'rgba(0,0,0,.5)' }}
        >
            <div className="modal-dialog modal-xl modal-dialog-centered">
                <div className="modal-content">

                    <div className="modal-header">
                        <div>
                            <h5 className="modal-title">Participantes do Evento</h5>
                            <small className="text-muted">
                                Total de inscritos: {calcularTotalInscritos()}
                            </small>
                        </div>

                        <button type="button" className="btn-close" onClick={onClose} />
                    </div>

                    <div className="modal-body overflow-hidden">
                        {isLoading ? (
                            <p className="text-center">Carregando participantes...</p>
                        ) : (
                            <div className="table-responsive-financeiro">
                                <table className="table table-striped align-middle w-100">
                                    <thead>
                                        <tr>
                                            <th width="60">Foto</th>
                                            <th>Participante</th>
                                            <th>Academia</th>

                                            {modalidadeEvento !== 'cursoSeminario' && (
                                                <>
                                                    <th>Categoria</th>
                                                    <th>Graduação</th>
                                                </>
                                            )}

                                            <th>Data de Cadastro</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {participantes.length > 0 ? (
                                            participantes.map((p, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        {renderListaImagem(p.foto)}
                                                    </td>

                                                    <td className="wrap-text">
                                                        {p.nome}
                                                    </td>

                                                    <td className="wrap-text">
                                                        {p.academia}
                                                    </td>

                                                    {modalidadeEvento !== 'cursoSeminario' && (
                                                        <>
                                                            <td>
                                                                {renderListaTexto(p.categoria)}
                                                            </td>
                                                            <td>
                                                                {renderListaTexto(p.graduacao)}
                                                            </td>
                                                        </>
                                                    )}

                                                    <td>
                                                        {p.dataInscricao
                                                            ? format(new Date(p.dataInscricao), 'dd/MM/yyyy')
                                                            : '-'}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td
                                                    colSpan={modalidadeEvento !== 'geral' ? 6 : 4}
                                                    className="text-center"
                                                >
                                                    Nenhum participante encontrado
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>

                    <div className="modal-footer">
                        <button className="btn btn-secondary" onClick={onClose}>
                            Fechar
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ModalParticipantes;
